var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_19_217",
    "data-name": "Component 19 \\u2013 217",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cart"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 20,
    height: 20,
    transform: "translate(4519 -80)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11",
    "data-name": "Mask Group 11",
    transform: "translate(-4519 80)",
    clipPath: "url(#cart)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_10_",
    "data-name": "svgexport-6 (10)",
    transform: "translate(4519 -80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    "data-name": "Path 4720",
    d: "M7.07,17.031a1.758,1.758,0,1,0,1.758-1.758A1.76,1.76,0,0,0,7.07,17.031Zm1.758-.586a.586.586,0,1,1-.586.586A.587.587,0,0,1,8.828,16.445Z",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4721",
    "data-name": "Path 4721",
    d: "M12.969,17.031a1.758,1.758,0,1,0,1.758-1.758A1.76,1.76,0,0,0,12.969,17.031Zm1.758-.586a.586.586,0,1,1-.586.586A.587.587,0,0,1,14.726,16.445Z",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4722",
    "data-name": "Path 4722",
    d: "M19.414,3.555H4.583L4.034,1.636a.586.586,0,0,0-.563-.425H.586a.586.586,0,0,0,0,1.172H3.029l2.829,9.9-.222.444a1.758,1.758,0,0,0,1.572,2.544H17.07a.586.586,0,0,0,0-1.172H7.209a.586.586,0,0,1-.524-.848l.162-.324H17.07a.586.586,0,0,0,.563-.425l2.344-8.2a.586.586,0,0,0-.563-.747Zm-2.786,8.2h-9.7L4.917,4.727h13.72Z",
    fill: "#2a2a2a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e13214159e6801ec0fa8fa52d16f2347.svg";
export { ForwardRef as ReactComponent };